module.exports = __webpack_public_path__ + "static/media/Lens-Fresh_Honey_TW.e41340e4.png";